/**
 * Wize Mobile API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PaymentMobile { 
    id?: number;
    generalOrderId?: number;
    accountId?: string;
    ibanIdentification?: string;
    formattedIbanIdentification?: string;
    portfolioId?: string;
    orderDate?: string;
    operationDate?: string;
    defferedExecutionDate?: string;
    valueDate?: string;
    accountingDate?: string;
    debitedGrossAmount?: number;
    debitedNetAmount?: number;
    debitedCurrencyId?: string;
    beneficiaryAmount?: number;
    beneficiaryCurrencyId?: string;
    analyticalCodeTypeId: string;
    chargesRuleValue: PaymentMobile.ChargesRuleValueEnum;
    beneficiaryAccountTypeValue: PaymentMobile.BeneficiaryAccountTypeValueEnum;
    beneficiaryAccount?: string;
    beneficiaryBic?: string;
    beneficiaryBranch?: string;
    beneficiarySwiftBicCodeId?: string;
    beneficiaryABARoutingNumber?: string;
    beneficiaryName?: string;
    beneficiaryBankName?: string;
    beneficiaryAddress: string;
    beneficiaryStreet?: string;
    beneficiaryStreet2?: string;
    beneficiaryStreetNumber?: string;
    beneficiaryPostalCode?: string;
    beneficiaryTown?: string;
    beneficiaryCommunications: string;
    debitMovementDescription?: string;
    beneficiaryCountryId: string;
    orderStatus?: PaymentMobile.OrderStatusEnum;
    apiOrderCreationStatus?: PaymentMobile.ApiOrderCreationStatusEnum;
    apiOrderStatus?: PaymentMobile.ApiOrderStatusEnum;
}
export namespace PaymentMobile {
    export const ChargesRuleValueEnum = {
        TO_ORDERING_PARTY: 'TO_ORDERING_PARTY',
        TO_BENEFICIARY: 'TO_BENEFICIARY',
        SHARED: 'SHARED'
    } as const;
    export type ChargesRuleValueEnum = typeof ChargesRuleValueEnum[keyof typeof ChargesRuleValueEnum];
    export const BeneficiaryAccountTypeValueEnum = {
        IBAN_ACCOUNT: 'IBAN_ACCOUNT',
        BANK_ACCOUNT: 'BANK_ACCOUNT',
        POST_ACCOUNT: 'POST_ACCOUNT',
        INTERNAL_ACCOUNT: 'INTERNAL_ACCOUNT',
        ABA_FEDWIRE_ACCOUNT: 'ABA_FEDWIRE_ACCOUNT'
    } as const;
    export type BeneficiaryAccountTypeValueEnum = typeof BeneficiaryAccountTypeValueEnum[keyof typeof BeneficiaryAccountTypeValueEnum];
    export const OrderStatusEnum = {
        ORDER_BOOK: 'ORDER_BOOK',
        PENDING: 'PENDING',
        VALIDATE: 'VALIDATE',
        WAITING_VALIDATION: 'WAITING_VALIDATION',
        DELETED: 'DELETED',
        PROVISIONAL_ACCOUNTING: 'PROVISIONAL_ACCOUNTING',
        PENDING_TO_CONFIRM: 'PENDING_TO_CONFIRM',
        ADVISORY: 'ADVISORY',
        WAITING_ADVISORY: 'WAITING_ADVISORY',
        REFUSED_ADVISORY: 'REFUSED_ADVISORY',
        LIMIT_EXPIRED: 'LIMIT_EXPIRED',
        EXECUTED: 'EXECUTED',
        WAITING_EXECUTION: 'WAITING_EXECUTION',
        TRADING_ACKNOWLEDGED: 'TRADING_ACKNOWLEDGED',
        TRADING_REJECTED: 'TRADING_REJECTED'
    } as const;
    export type OrderStatusEnum = typeof OrderStatusEnum[keyof typeof OrderStatusEnum];
    export const ApiOrderCreationStatusEnum = {
        PENDING_AUTHORIZATION: 'PENDING_AUTHORIZATION',
        WAITING_AUTHORIZATION_CONFIRMATION: 'WAITING_AUTHORIZATION_CONFIRMATION',
        AUTHORIZATION_SUCCEEDED: 'AUTHORIZATION_SUCCEEDED',
        AUTHORIZATION_FAILED: 'AUTHORIZATION_FAILED',
        AUTHORIZATION_EXPIRED: 'AUTHORIZATION_EXPIRED'
    } as const;
    export type ApiOrderCreationStatusEnum = typeof ApiOrderCreationStatusEnum[keyof typeof ApiOrderCreationStatusEnum];
    export const ApiOrderStatusEnum = {
        DRAFT: 'DRAFT',
        PENDING: 'PENDING',
        DECLINED: 'DECLINED',
        APPROVED: 'APPROVED',
        EXECUTED: 'EXECUTED',
        ACCOUNTED: 'ACCOUNTED',
        FAILED: 'FAILED',
        EXPIRED: 'EXPIRED'
    } as const;
    export type ApiOrderStatusEnum = typeof ApiOrderStatusEnum[keyof typeof ApiOrderStatusEnum];
}


